__turbopack_context__.v({
  "headless-optimizely-form": "lcRLqG_headless-optimizely-form",
  "headless-optimizely-form__content": "lcRLqG_headless-optimizely-form__content",
  "headless-optimizely-form__content--reduce-spacing": "lcRLqG_headless-optimizely-form__content--reduce-spacing",
  "headless-optimizely-form__fieldset": "lcRLqG_headless-optimizely-form__fieldset",
  "headless-optimizely-form__footer": "lcRLqG_headless-optimizely-form__footer",
  "headless-optimizely-form__heading": "lcRLqG_headless-optimizely-form__heading",
  "headless-optimizely-form__legend": "lcRLqG_headless-optimizely-form__legend",
  "headless-optimizely-form__separator": "lcRLqG_headless-optimizely-form__separator",
  "headless-optimizely-form__sub-heading": "lcRLqG_headless-optimizely-form__sub-heading",
});
